import InputValidator from './input_validator'

export default class FormValidator {

  static validate(formFields, actionName) {
    return InputValidator.validate(formFields, actionName)
  }
}
